import { AxiosError } from 'axios';

export const RISK_COMPLIANCE_ERROR_CODES = {
  PROFILE_NOT_FOUND: 'PROFILE_NOT_FOUND',
  NO_DUNS_MATCH: 'NO_DUNS_MATCH',
  INVALID_DUNS: 'INVALID_DUNS',
  DUNS_REQUIRED: 'DUNS_REQUIRED',
  COMPANY_NAME_REQUIRED: 'COMPANY_NAME_REQUIRED',
  DUNS_VALIDATION_FAILED: 'DUNS_VALIDATION_FAILED',
  DUNS_NOT_LINKED: 'DUNS_NOT_LINKED',
  DNB_NOT_CONFIGURED: 'DNB_NOT_CONFIGURED',
  UNSUPPORTED_BLOCK: 'UNSUPPORTED_BLOCK',
  INTERNAL: 'INTERNAL_ERROR',
};

export const RISK_COMPLIANCE_BLOCK_STATUS = {
  EMPTY: 'empty',
  LOADED: 'loaded',
  UNAVAILABLE: 'unavailable',
  NO_DATA: 'no_data',
  FETCHING: 'fetching',
};

export const mapRiskComplianceError = (error, labels) => {
  const responseData = error instanceof AxiosError ? error.response?.data : undefined;
  const code = responseData?.code;
  switch (code) {
    case RISK_COMPLIANCE_ERROR_CODES.NO_DUNS_MATCH:
    case RISK_COMPLIANCE_ERROR_CODES.INVALID_DUNS:
      return labels.noDunsMatch;
    case RISK_COMPLIANCE_ERROR_CODES.DNB_NOT_CONFIGURED:
      return labels.dnbNotConfigured;
    case RISK_COMPLIANCE_ERROR_CODES.DUNS_VALIDATION_FAILED:
      return labels.dnbValidationFailed;
    case RISK_COMPLIANCE_ERROR_CODES.INTERNAL:
    case RISK_COMPLIANCE_ERROR_CODES.UNSUPPORTED_BLOCK:
      return labels.generic;
    default:
      break;
  }

  const raw = responseData?.error || responseData?.message || error?.message || String(error);
  if (raw.length > 180 || raw.includes('{') || raw.includes('transactionDetail')) {
    return labels.generic;
  }

  return raw || labels.generic;
};
